import React from 'react';
import configJSON from 'config.json';
import Layout from 'components/layout';
import endpoint from 'utils/endpoint';
import BuyNowCard from 'components/pages/newhomes/components/buy-now-card';
import BackArrowIcon from 'components/icon/back-arrow-icon';
import NextLink from 'next/link';
import HeadData from 'components/head-data';
import styles from './style.module.scss';
import { HttpRequestMethodTypes } from 'types/HttpRequestMethodTypes';
import { createGetServerSideProps } from 'utils/next/shared-getServerSideProps';
import { NOT_FOUND } from 'constants/not-found';
import { isZoocasaTenant } from '@tenants/utils/which-tenant';
import type { PreConstructionProject, GetProjectsResponse } from '@zoocasa/pre-construction';
import type { HandlerType } from 'utils/next/shared-getServerSideProps';
import type { FeaturesType } from 'contexts/features';
import type { TenantTypes } from '@tenants/manager';

const getServerSidePropsHandler: HandlerType<BuyNowComingSoonPage> = async (context, features?: FeaturesType, tenant?: TenantTypes) => {
  // Only allow access to this page on the Zoocasa tenant
  if (!isZoocasaTenant(tenant.id, features)) {
    return NOT_FOUND;
  }

  let listings = [];
  let pageTitle: 'Buy Today' | 'Coming Soon' = 'Buy Today';
  const routeName: 'buy-today' | 'coming-soon' = context.query['precon-type'] as 'buy-today' | 'coming-soon';
  const { available, upcoming }: GetProjectsResponse = await endpoint('/services/pre-construction/v1/projects', HttpRequestMethodTypes.GET, undefined, undefined, undefined, configJSON.preconHost);

  if (routeName === 'buy-today') {
    listings = available ? available : [];
  } else {
    pageTitle = 'Coming Soon';
    listings = upcoming ? upcoming : [];
  }

  return {
    props: {
      listings,
      pageTitle,
      routeName,
    },
  };
};

export const getServerSideProps = createGetServerSideProps<BuyNowComingSoonPage>(getServerSidePropsHandler);

export type BuyNowComingSoonPage = {
  listings: PreConstructionProject[];
  pageTitle: 'Buy Today' | 'Coming Soon';
  routeName: 'buy-today' | 'coming-soon';
};

export default function BuyNowComingSoonPage(props: BuyNowComingSoonPage) {
  const headerData = {
    title: `Toronto Pre Construction Homes Available ${props.routeName === 'buy-today' ? 'Today' : 'Soon'}: Developments and New Construction | Zoocasa`,
    metaDescription: 'Zoocasa provides all new pre-construction developments for new residential homes, condos, townhouses, and new real estate. Toronto and more.',
  };

  return (
    <Layout>
      <HeadData data={headerData} />
      <section className={styles.component}>
        <div className={styles.wrapper}>
          <div className={styles['heading']}>
            <NextLink href='/newhomes'>
              <BackArrowIcon className={styles['back-arrow']} />
            </NextLink>
            <h1>
              {props.pageTitle}
            </h1>
            <span/>
          </div>
          <span className={styles['number-of-developments']}>
            {props.listings.length} Developments
          </span>
          <div className={styles.grid}>
            {props.listings.map((listing, index) => {
              return (
                <BuyNowCard key={index} listing={listing} />
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}
